// If the carousel is on a larger screen, set the height of the carousel to the height of the content
export const setCarouselHeight = (carousel: HTMLElement) => {
  const carouselContent = carousel.querySelector(".carousel__content") as HTMLElement;
  const carouselWrapper = carousel.querySelector(".carousel__wrapper") as HTMLElement;
  const text = carousel.querySelector(".carousel__text") as HTMLElement;
  const textElementHeight = text != null ? text.offsetHeight : 0;
  const textMargin = text != null ? parseInt(window.getComputedStyle(text).marginBottom) : 0;
  const carouselContentPadding = parseInt(window.getComputedStyle(carouselContent).paddingTop) + parseInt(window.getComputedStyle(carouselContent).paddingBottom);
  
  if (window.innerWidth > 768) {
    // Get heights of the carousel and the content
    const headingHeight = textElementHeight + textMargin;
    const carouselHeight = carouselWrapper.offsetHeight + headingHeight + carouselContentPadding;

    // Set height of the carousel
    carousel.style.height = `${carouselHeight}px`;
    carouselContent?.classList.add("carousel__content--loaded");
  } else {
    // Reset height of the carousel
    carousel.style.height = 'auto';
    carouselContent?.classList.remove("carousel__content--loaded");
  }
}

// Set carousel translations
export const carouselTranslation = (carousel: HTMLElement) => {
  let ariaTranslationsString = (carousel.querySelector(".carousel__wrapper") as HTMLElement).dataset.ariaText as string;
  let ariaTranslationsArray = ariaTranslationsString.split(', ') as string[];

  return  {
    prev: ariaTranslationsArray[0],
    next: ariaTranslationsArray[1],
    first: ariaTranslationsArray[2],
    last: ariaTranslationsArray[3],
    slideX: ariaTranslationsArray[4],
    carousel: ariaTranslationsArray[5],
    select: ariaTranslationsArray[6],
    slide: ariaTranslationsArray[7],
    slideLabel: ariaTranslationsArray[8]
  };
}

// When the carousel is in viewport, set the height of the carousel
export const setCarouselHeightWhenInViewport = (carousel: HTMLElement) => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setCarouselHeight(carousel);
      }
    });
  }, { threshold: 0.1 });

  observer.observe(carousel);
}